import { Component, NgModule, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import {
  FileType,
  GlobalConstantsSonstige,
  GlobalConstantsTexte,
  GlobalFunctions
} from 'globales-projekt-angular';
import { Lightbox, LightboxModule } from 'ngx-lightbox';
import { TableAuspraegungGebaeude } from 'src/app/data/table/table-auspraegung-gebaeude.model';
import { TableFlaecheVolumen } from 'src/app/data/table/table-flaechen-volumen.model';
import { TableInvBedKb } from 'src/app/data/table/table-inv-bed-kb.model';
import { TableInvBedKe } from 'src/app/data/table/table-inv-bed-ke.model';
import { TableSelectGebaeude } from 'src/app/data/table/table-select-gebaeude.model';
import { TableTierplaetze } from 'src/app/data/table/table-tierplaetze.model';
import { UserAuswahlGebaeude } from 'src/app/data/user/user-auswahl-gebaeude.model';
import { UserAuswahlSelectGebaeude } from 'src/app/data/user/user-auswahl-select-gebaeude.model';
import { Datei } from 'src/app/data/ws/dbKlassen/datei.model';
import { Ergebnisse } from 'src/app/data/ws/ergebnis/ergebnisse.model';
import { Gebaeude } from 'src/app/data/ws/dbKlassen/gebaeude.model';
import { ErgebnisInvBedKbEinzel } from 'src/app/data/ws/ergebnis/gebaeude/invBedKb/ergebnis-inv-bed-kb-einzel.model';
import { Functions } from 'src/app/functions/functions.module';
import { ConstantsTableColsErgebnisAuspraegungGebaeude } from 'src/app/immutable/cols/constants-table-cols-ergebnis-auspraegung-gebaeude';
import { ConstantsTableColsErgebnisFlaechenVolumen } from 'src/app/immutable/cols/constants-table-cols-ergebnis-flaechen-volumen';
import { ConstantsTableColsErgebnisInvBedKb } from 'src/app/immutable/cols/constants-table-cols-ergebnis-inv-bed-kb';
import { ConstantsTableColsErgebnisInvBedKe } from 'src/app/immutable/cols/constants-table-cols-ergebnis-inv-bed-ke';
import { ConstantsTableColsErgebnisTierplaetze } from 'src/app/immutable/cols/constants-table-cols-ergebnis-tierplaetze';
import { ConstantsTableColsSelectGebaeudeList } from 'src/app/immutable/cols/constants-table-cols-select-gebaeude-list';
import { ApiService } from 'src/app/services/api.service';
import { LocalService } from 'src/app/services/local.service';
import { FormControl } from '@angular/forms';
import { TableSelectKge } from 'src/app/data/table/table-select-kge.model';

@Component({
  selector: 'app-ergebnisse',
  templateUrl: './ergebnisse.component.html',
  styleUrls: ['./ergebnisse.component.css'],
})
export class ErgebnisseComponent implements OnInit {
  @NgModule({
    imports: [LightboxModule],
  })
  position = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);

  ergebnisse!: Ergebnisse;
  ergebnisInvBedKbEinzelGesamt!: ErgebnisInvBedKbEinzel;

  dataSourceSelectGebaeude!: MatTableDataSource<TableSelectGebaeude>;
  dataSourceErgebnisAuspraegungGebaeude!: MatTableDataSource<TableAuspraegungGebaeude>;
  dataSourceErgebnisTierplaetze!: MatTableDataSource<TableTierplaetze>;
  dataSourceErgebnisFlaechenVolumen!: MatTableDataSource<TableFlaecheVolumen>;
  dataSourceErgebnisInvBedKe!: MatTableDataSource<TableInvBedKe>;
  dataSourceErgebnisInvBedKb!: MatTableDataSource<TableInvBedKb>;

  displayedColsSelectGebaeude!: string[];
  displayedColsAuspraegungGebaeude!: string[];
  displayedColsTierplaetze!: string[];
  displayedColsFlaechenVolumen!: string[];
  displayedColsErgebnisInvBedKe!: string[];
  displayedColsErgebnisInvBedKb!: string[];
  displayedColsErgebnisInvBedKbHeader!: string[];

  userAuswahlSelectGebaeudeList: UserAuswahlSelectGebaeude[] = [];
  showEmpty = false;
  hasUnselectedKge: boolean = false;
  unselectedKgeLabels: string[] = [];

  constructor(
    private apiService: ApiService,
    public localService: LocalService,
    private lightbox: Lightbox
  ) { }

  ngOnInit(): void {
    this.localService.diagramErgebnisse.next(null);
    this.localService.ergebnisseComponentRef.next(this);

    if (this.localService.selectedGebaeudeList.value.length === 0) return;

    this.userAuswahlSelectGebaeudeList = this.localService.selectedGebaeudeList.value.map(
      entry => new UserAuswahlSelectGebaeude(entry.idGebaeude, true)
    );

    this.localService.mainComponentRef.value!.waitingForDataSpinner(true);

    this.apiService.postKge(this.userAuswahlSelectGebaeudeList.map(entry => entry.idGebaeude)).subscribe((response) => {


      this.localService.kgeList.next(response);

      const mergedSelectedList: TableSelectKge[] = response.map(entry => {
        const previous = this.localService.selectedKgeList.value.find(prev => prev.idKge === entry.idKge);
        return {
          ...entry,
          isSelected: previous?.isSelected === false ? false : true
        };
      });

      this.localService.selectedKgeList.next(mergedSelectedList);

      this.hasUnselectedKge = mergedSelectedList.some(entry => entry.isSelected === false);

      this.unselectedKgeLabels = mergedSelectedList
        .filter(entry => entry.isSelected === false)
        .map(entry => entry.kge + " " + entry.bezeichnung);

      this.calcAndRefreshPage(true);
        
      this.localService.mainComponentRef.value!.waitingForDataSpinner(false);
    });
  }

  calcAndRefreshPage(firstLoad: boolean): void {


    this.localService.mainComponentRef.value!.waitingForDataSpinner(true);
    this.apiService
      .postErgebnisse(this.getUserAuswahlGebaeude())
      .subscribe((response) => {
        this.ergebnisse = response;

        response.ergebnisGebaeudeList.forEach((entry) => {
          if (
            entry.gebaeude.dateiList &&
            entry.gebaeude.dateiList.length > 0
          ) {
            entry.gebaeude.dateiList.forEach((datei) => {
              datei.base64Image = GlobalFunctions.getUrlForFile(
                datei.mimetype,
                datei.datei
              );
            });
          }
        });

        this.localService.diagramErgebnisse.next(response);
        this.localService.fromErgebnis.next(true);

        this.createAndSetErgebnisHeaderDatasource(firstLoad);
        this.localService.mainComponentRef.value!.waitingForDataSpinner(false);

        this.localService.mainComponentRef.value!.onClickUp();
      });
  }

  onClickToggleAnzeigen(gebaeude: Gebaeude) {
    let entry: UserAuswahlSelectGebaeude =
      this.userAuswahlSelectGebaeudeList.find(
        (entry) => entry.idGebaeude === gebaeude.idGebaeude
      )!;
    entry.selected = !entry.selected;

    this.calcAndRefreshPage(false);
  }


  getUserAuswahlGebaeude(): UserAuswahlGebaeude {
    let userAuswahlGebaeude: UserAuswahlGebaeude = new UserAuswahlGebaeude();

    this.userAuswahlSelectGebaeudeList.forEach((entry) => {
      if (entry.selected && entry.idGebaeude !== null) {
        userAuswahlGebaeude.idGebaeudeList.push(entry.idGebaeude);
      }
    });

    userAuswahlGebaeude.preisfaktor = this.localService.preisfaktor.value;
    userAuswahlGebaeude.preisstand = this.localService.selectedPreisstand.value.preisstand;



    userAuswahlGebaeude.idKgeList = this.localService.selectedKgeList.value
      .filter((entry) => entry.isSelected)
      .map((entry) => entry.idKge);

    return userAuswahlGebaeude;
  }

  createAndSetErgebnisHeaderDatasource(
    refreshSelectGebaeude: boolean
  ) {
    const length: number = this.ergebnisse.ergebnisGebaeudeList.length;

    {
      if (refreshSelectGebaeude) {
        this.dataSourceSelectGebaeude = new MatTableDataSource(
          TableSelectGebaeude.getTableSelectGebaeudeList(this.ergebnisse)
        );
        this.displayedColsSelectGebaeude =
          ConstantsTableColsSelectGebaeudeList.getColumns();
      }
    }
    {

      this.dataSourceErgebnisAuspraegungGebaeude = new MatTableDataSource(
        TableAuspraegungGebaeude.getTableAuspraegungGebaeude(this.ergebnisse)
      );

      this.displayedColsAuspraegungGebaeude =
        ConstantsTableColsErgebnisAuspraegungGebaeude.getColumns(
          length > 1 ? length - 1 : length
        );

    }
    {
      if (!this.localService.istGebaeude.value) {
        this.dataSourceErgebnisTierplaetze = new MatTableDataSource(
          TableTierplaetze.getTableTierlaetzeList(this.ergebnisse)
        );

        this.displayedColsTierplaetze =
          ConstantsTableColsErgebnisTierplaetze.getColumns(
            length > 1 ? length - 1 : length
          );
      }
    }
    {
      this.displayedColsFlaechenVolumen =
        ConstantsTableColsErgebnisFlaechenVolumen.getColumns(
          length > 1 ? length - 1 : length
        );

      this.dataSourceErgebnisFlaechenVolumen = new MatTableDataSource(
        TableFlaecheVolumen.getTableFlaecheVolumenList(this.ergebnisse)
      );
    }
    {
      this.displayedColsErgebnisInvBedKe =
        ConstantsTableColsErgebnisInvBedKe.getColumns(length > 1 ? length - 1 : length);

      this.dataSourceErgebnisInvBedKe = new MatTableDataSource(
        TableInvBedKe.getTableInvBedKeList(this.ergebnisse)
      );
    }
    {
      this.dataSourceErgebnisInvBedKb = new MatTableDataSource(
        TableInvBedKb.getTableInvBedKbList(this.ergebnisse)
      );

      this.displayedColsErgebnisInvBedKb =
        ConstantsTableColsErgebnisInvBedKb.getColumns(length > 1 ? length - 1 : length);

      this.displayedColsErgebnisInvBedKbHeader =
        ConstantsTableColsErgebnisInvBedKb.getColumnsHeader(length > 1 ? length - 1 : length);
    }
  }

  adjustIndexKb(i: number): number {
    return Math.floor((i - 1) / 2);
  }

  onOpenPdf(gebaeude: Gebaeude) {
    this.localService.mainComponentRef.value!.waitingForDataSpinner(true);
    this.apiService
      .getGebaeudeDatei(
        gebaeude.dateiList?.find((datei) => datei.mimetype === FileType.PDF)!
          .idDatei
      )
      .subscribe((response) => {
        GlobalFunctions.openInTab(response, FileType.PDF);
        this.localService.mainComponentRef.value!.waitingForDataSpinner(false);
      });
  }

  hasGebaeudePDfs(gebaeude: Gebaeude): boolean {
    return (
      gebaeude.dateiList?.length > 0 &&
      gebaeude.dateiList.some((datei) => datei.mimetype === FileType.PDF)
    );
  }

  hasGallery(gebaeude: Gebaeude): boolean {
    return (
      gebaeude.dateiList?.length > 0 &&
      gebaeude.dateiList.some((datei) => datei.mimetype !== FileType.PDF)
    );
  }

  openGallery(gebaeude: Gebaeude): void {
    Functions.openGallery(this.lightbox, gebaeude);
  }

  getMainGalleryImage(gebaeude: Gebaeude): string {
    const imageFiles: Datei[] = gebaeude.dateiList.filter(
      (datei) => datei.mimetype !== FileType.PDF
    );

    if (imageFiles.length > 0) {
      const sortedImageFiles = imageFiles.sort((a, b) => {
        if (
          (a.sortierung === null || a.sortierung === undefined) &&
          (b.sortierung === null || b.sortierung === undefined)
        )
          return 0;
        if (a.sortierung === null || a.sortierung === undefined) return -1;
        if (b.sortierung === null || b.sortierung === undefined) return 1;
        return a.sortierung - b.sortierung;
      });

      return sortedImageFiles[0].base64Image;
    }

    return '';
  }

  public onClickDownloadExcel() {
    this.showEmpty = true; // ToDo mal schauen ob ich showEmpty überhaupt brauche
    this.localService.mainComponentRef.value!.waitingForDataSpinner(true);


    this.apiService
      .postDownloadExcel(this.getUserAuswahlGebaeude())
      .subscribe((response: Blob) => {
        GlobalFunctions.downloadFile(
          FileType.XLSX,
          response,
          GlobalConstantsTexte.DOWNLOAD_FILE_NAME,
          FileType.XLSX_SHORT
        );
        this.showEmpty = false;
        this.localService.mainComponentRef.value!.waitingForDataSpinner(false);
      });
  }

  isGebaeudeSelected(gebaeude: Gebaeude): boolean {
    const eintrag = this.userAuswahlSelectGebaeudeList.find(
      (entry) => entry.idGebaeude === gebaeude.idGebaeude
    );
    return eintrag?.selected ?? false;
  }
}
